"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._deleteAllPitOperation = exports._getPitExcavator = exports._getPitDumpTruck = exports._getPitOperationById = exports._getPitOperation = exports._deletePitOperation = exports._editPitOperation = exports._createPitOperation = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _createPitOperation = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/pit';
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.post(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            data: {
                id: data.data.id
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: ''
            } });
    }
});
exports._createPitOperation = _createPitOperation;
const _editPitOperation = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/pit/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.put(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, errorMessage: response.errorMessage, data: {
                id: ''
            } });
    }
});
exports._editPitOperation = _editPitOperation;
const _deletePitOperation = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/pit/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.delete(url, config);
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: true, errorMessage: response.errorMessage, errorCode: response.errorCode, data: {
                id: ''
            } });
    }
});
exports._deletePitOperation = _deletePitOperation;
const _getPitOperation = ({ skip, take, filter, sort }, filterChild) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const filterChildString = {
        logic: 'and', filters: [{ field: 'dumptruck_no', operator: 'eq', value: filterChild }]
    };
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/configuration/pit';
    const config = {
        params: {
            skip,
            take,
            filter: filterChild == '' ? filterString : undefined,
            sort: sortString,
            filter_child: filterChild == '' ? undefined : filterChildString
        },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getPitOperation = _getPitOperation;
const _getPitOperationById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/pit/${id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError, errorCode, errorMessage, data: {
                area: {},
                area_id: '',
                area_name: '',
                brand: {},
                brand_id: '',
                brand_name: '',
                checkpoint: {},
                checkpoint_id: '',
                checkpoint_name: '',
                contractor: {},
                contractor_id: '',
                contractor_name: '',
                created_date: new Date(),
                dump_truck: [],
                dumpTruck_name: '',
                excavator: {},
                excavator_id: '',
                excavator_no: '',
                id: '',
                is_active: { status: '', value: false },
                modified_by: '',
                modified_date: new Date(),
                pit: {},
                pit_id: '',
                pit_name: '',
                seam: {},
                seam_id: '',
                seam_name: '',
                dataChild: [],
                expanded: false,
            }, countData: 0
        };
    }
});
exports._getPitOperationById = _getPitOperationById;
const _getPitDumpTruck = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/dumptruck-pit';
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.post(url, arg, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getPitDumpTruck = _getPitDumpTruck;
const _getPitExcavator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/excavator-pit/${arg.contractor_id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getPitExcavator = _getPitExcavator;
const _deleteAllPitOperation = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/delete-pit';
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.delete(url, config);
        return {
            isError: response.data.isError,
            errorCode: response.data.errorCode,
            errorMessage: response.data.errorMessage,
            data: {},
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { data: {}, isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage });
    }
});
exports._deleteAllPitOperation = _deleteAllPitOperation;
